import React, { useState, useEffect } from "react";
import styles from "./languagepals.module.css";
import { FaUserFriends } from "react-icons/fa";
import defaultImage from "../../appImges/avatartTemplate/default_img.png";
import { Link } from "react-router-dom";
import axios from "axios";

const apiUrl = process.env.REACT_APP_URL;

const LanguagePalsComp = ({ isOwn, viewedUsername }) => {
  /* This is a side component that is used for quick access to the user's Pals (friends). The user can view up to 3 Pals in this component, and he / she can also search for any of his / her Pals. The component is integrated in multiple pages of the website, and is also used to display Pals of a Pal of the active user. */
  const [username, setUsername] = useState(null);
  const [palsData, setPalsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredPals, setFilteredPals] = useState([]);

  let viewMoreLink = "/pals";

  if (!isOwn) {
    viewMoreLink = `/pals/${viewedUsername}`;
  }

  // Fetch pals data
  useEffect(() => {
    const fetchPalsData = async () => {
      try {
        let sessionRes;

        if (isOwn) {
          sessionRes = await axios.get(`${apiUrl}/auth/user`, {
            withCredentials: true,
          });

          if (sessionRes.status === 200 && sessionRes.data.success) {
            setUsername(sessionRes.data.username);
          }
        } else {
          setUsername(viewedUsername);
        }

        if (!username) {
          return;
        }

        const palsRes = await axios.get(
          `${apiUrl}/relationships/pals/${username}`,
          { withCredentials: true }
        );

        if (palsRes.status === 200) {
          setPalsData(palsRes.data);
        }
      } catch (e) {
        console.error("Failed to fetch pals data", e);
      }
    };

    fetchPalsData();
  }, [isOwn, username, viewedUsername]);

  useEffect(() => {
    setFilteredPals(palsData);
  }, [palsData]);

  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);

    if (searchValue === "") {
      // If the search input is empty, reset to the first 3 pals
      setFilteredPals(palsData.slice(0, 3));
    } else {
      // Otherwise, filter pals based on the search term
      const filtered = palsData.filter((pal) =>
        pal.friend.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredPals(filtered);
    }
  };

  return (
    <div className={styles.mainPalsSearch}>
      <h2>Pals {!isOwn && <span> - {viewedUsername}</span>}</h2>

      {palsData && palsData.length > 0 ? (
        <>
          <div className={styles.searchButton}>
            <input
              type="text"
              placeholder="Search pal"
              className={styles.searchInput}
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>

          <div className={styles.palsList}>
            {filteredPals.slice(0, 3).map((pal) => (
              <Link
                key={pal.friend}
                to={`/profile/${pal.friend}`}
                className={styles.palLink}
              >
                <figure>
                  <img
                    src={`${apiUrl}/${pal.img_link}` || defaultImage}
                    alt={pal.friend}
                  />
                  <figcaption className={styles.palFriendName}>
                    {pal.friend}
                  </figcaption>
                </figure>
              </Link>
            ))}
          </div>

          <Link className={styles.btnMore} to={viewMoreLink}>
            Show more{" "}
            <span className={styles.iconFriends}>
              <FaUserFriends />
            </span>
          </Link>
        </>
      ) : (
        <p className={styles.noPalsMessage}>
          {isOwn && (
            <span>
              You don't have any pals yet. Connect with people and start
              building your friendship network!
            </span>
          )}
          {!isOwn && <span>No Pals yet.</span>}
        </p>
      )}
    </div>
  );
};

export default LanguagePalsComp;
